/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
 import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : REPORT SETTINGS : STYLES --------------- ++++++++++ */
export default theme => ({
	settings: {
		'& .settings_content': {
			'& .settings_section': {
				margin: `${pxToEm(20)} 0`,
				'& .settings_subheading': {
					marginBottom: pxToEm(15)
				},
	
				'& .report_name': {	
					width: '100%',
					maxWidth: '65vw',
				},
				'&.isValid-false': {
					'& .formelement': {
						color: theme.color.attention.medium.contrast,
						borderColor: 'transparent'
					},
				}, 

			},
		},
	}
});
